export const TRANSPORT_COUNTRIES = [
  'SE',
  'DK',
  'FI',
  'EE',
  'LV',
  'LT',
  'PL',
  'DE',
  'NL',
  'BE',
  'FR',
  'AT',
  'CZ',
  'SK',
  'SI',
  'HU',
  'RO',
  'BG',
  'HR',
  'GR',
  'IT'
] as const;

export type TransportCountryCode = (typeof TRANSPORT_COUNTRIES)[number];

export const TRANSPORT_COUNTRIES_AS_CHUNKS = TRANSPORT_COUNTRIES.reduce<
  TransportCountryCode[][]
>((acc, current, index) => {
  if (index % 5 === 0) acc.push([]);
  acc[acc.length - 1].push(current);
  return acc;
}, []);
